"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatLog = void 0;
function formatLog(log) {
  let {
    args,
    eventName
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, log), {}, {
    blockHash: log.blockHash ? log.blockHash : null,
    blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
    logIndex: log.logIndex ? Number(log.logIndex) : null,
    transactionHash: log.transactionHash ? log.transactionHash : null,
    transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null
  }, eventName ? {
    args,
    eventName
  } : {});
}
exports.formatLog = formatLog;
//# sourceMappingURL=log.js.map